"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { Media, ToggleButtonGroup, ToggleButtonGroupItem, Tooltip } from "@opensea/ui-kit";
import { Browse, GridOn, GridView, TableRows, TableRowsNarrow } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useContextSelector } from "use-context-selector";
import { FilterLayoutContext } from "../layout/FilterLayoutProvider";
import { useItemView } from "./ItemViewProvider";
const useViews = () => {
  const $ = _c(26);
  const t = useTranslations("ItemViewToggle");
  let t0;
  if ($[0] !== t) {
    t0 = t("grid");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      title: t0,
      itemView: "grid",
      icon: GridView
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("gridCompact");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      title: t2,
      itemView: "gridCompact",
      icon: GridOn
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("mosaic");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      title: t4,
      itemView: "mosaic",
      icon: Browse
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("table");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      title: t6,
      itemView: "table",
      icon: TableRows
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("tableCompact");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      title: t8,
      itemView: "tableCompact",
      icon: TableRowsNarrow
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t3 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = [t1, t3, t5, t7, t9];
    $[20] = t1;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export function ItemViewToggle(t0) {
  const $ = _c(25);
  const {
    views
  } = t0;
  const {
    itemView,
    setItemView
  } = useItemView();
  const [isFilterSidePanelOpen, isSideModuleOpen] = useContextSelector(FilterLayoutContext, _temp);
  const staticViews = useViews();
  let t1;
  if ($[0] !== staticViews || $[1] !== views) {
    t1 = views ? staticViews.filter(view => views.includes(view.itemView)) : staticViews;
    $[0] = staticViews;
    $[1] = views;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filteredViews = t1;
  let t2;
  if ($[3] !== filteredViews || $[4] !== itemView) {
    let t3;
    if ($[6] !== itemView) {
      t3 = t4 => {
        const {
          itemView: iconItemView
        } = t4;
        return iconItemView === itemView;
      };
      $[6] = itemView;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = filteredViews.findIndex(t3);
    $[3] = filteredViews;
    $[4] = itemView;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const iconIndex = Math.max(t2, 0);
  const t3 = filteredViews[iconIndex];
  let t4;
  if ($[8] !== filteredViews || $[9] !== iconIndex || $[10] !== setItemView) {
    t4 = () => {
      const nextIndex = (iconIndex + 1) % filteredViews.length;
      setItemView(filteredViews[nextIndex].itemView);
    };
    $[8] = filteredViews;
    $[9] = iconIndex;
    $[10] = setItemView;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3.icon || $[13] !== t4) {
    t5 = <Media lessThan="lg"><Button icon={t3.icon} onClick={t4} size="sm" variant="secondary" /></Media>;
    $[12] = t3.icon;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = `${String(isFilterSidePanelOpen)}${String(isSideModuleOpen)}`;
  const t7 = filteredViews[iconIndex];
  const t8 = t7.itemView;
  let t9;
  if ($[15] !== filteredViews) {
    t9 = filteredViews.map(_temp2);
    $[15] = filteredViews;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== setItemView || $[18] !== t6 || $[19] !== t7.itemView || $[20] !== t9) {
    t10 = <Media greaterThanOrEqual="lg"><ToggleButtonGroup className="self-start" key={t6} onValueChange={setItemView} value={t8} variant="secondary">{t9}</ToggleButtonGroup></Media>;
    $[17] = setItemView;
    $[18] = t6;
    $[19] = t7.itemView;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp2(t0) {
  const {
    title,
    itemView: iconItemView_0,
    icon: Icon
  } = t0;
  return <Tooltip content={title} key={iconItemView_0}><span className="w-full"><ToggleButtonGroupItem icon={Icon} value={iconItemView_0} /></span></Tooltip>;
}
function _temp(v) {
  return [v.isFilterSidePanelOpen, v.isSideModuleOpen];
}